const IframeEventsMixin = {

    methods: {
        sendEvent(data) {
          if (window.parent) {
            window.parent.postMessage(data, '*');
          }
        }
    }
};

export default IframeEventsMixin;


